import React from 'react';

export default function PlusIcon({className}) {
	return (
        <svg className={className ? className : ''} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 10.3" preserveAspectRatio="xMidYMid meet"><path d="M2.4 10.3h8.2c1.3 0 2.4-1.1 2.4-2.4V2.4C13 1.1 12 0 10.6 0H2.4C1.1 0 0 1.1 0 2.4v5.5c0 1.4 1.1 2.4 2.4 2.4zm0-9h8.2c.5 0 .9.3 1.1.8l-.4.3-4.8 3.3-4.7-3.3-.5-.3c.2-.5.6-.8 1.1-.8zm9.4 6.6c0 .6-.5 1.1-1.1 1.1H2.4c-.6 0-1.1-.5-1.1-1.1V3.6L6.2 7c.2.1.5.1.7 0l4.9-3.3v4.2z"/></svg>
	);
}
